import { CheckCircleIcon, FunnelIcon, PlusIcon } from '@heroicons/react/24/outline';
import type { FieldValues } from 'react-hook-form';
import Button from '@/components/UI/Button';
import { type ChangeOrderImpactType, ImpactStats } from '@/features/ChangeOrder/Summary/ImpactStats';

export type TableHeaderProps = {
  title: string;
  totalApproved: number;
  totalRequested: number;
  impactValue: number;
  impactType: ChangeOrderImpactType;
  appliedFilters: FieldValues;
  onFiltersOpen?: (e: React.MouseEvent) => void;
  onAdd?: (e: React.MouseEvent) => void;
};

export function TableHeader({
  title,
  totalApproved,
  totalRequested,
  impactValue,
  impactType,
  appliedFilters = {},
  onFiltersOpen,
  onAdd,
}: TableHeaderProps) {
  const filtersCount = Object.keys(appliedFilters).filter((filterKey) => !!appliedFilters[filterKey]);

  return (
    <div className='bg-white flex justify-between items-center p-2'>
      <div>
        <p className='text-lg font-medium mb-3'>{title}</p>
        <div className='flex gap-5'>
          <p className='flex gap-1'>
            <CheckCircleIcon className='w-5 h-5 text-primaryColor-normal' /> Total C/Os Approved: {totalApproved}
          </p>
          <p>Total C/Os Requested: {totalRequested}</p>
          <ImpactStats label='Total Impact' value={impactValue} className='text-sm' type={impactType} />
        </div>
      </div>
      <div className='flex gap-4'>
        <Button
          btnStyle='btn-neutral'
          customClassName='w-8'
          icon={
            <div className='flex items-center gap-2'>
              <div className='relative'>
                <FunnelIcon className='h-5 w-5' />
                {filtersCount.length > 0 && (
                  <span className='absolute -top-1 left-3.5 bg-green-500 rounded-full text-[10px] px-1 text-white z-10'>
                    {filtersCount.length}
                  </span>
                )}
              </div>
            </div>
          }
          onClick={onFiltersOpen}
        />
        <Button btnStyle='primary' label='Add' icon={<PlusIcon />} onClick={onAdd} />
      </div>
    </div>
  );
}
